module.exports = __webpack_public_path__ + "static/2-de724a819178278eacf93d09cd5f2e1b.jpeg";